export default __webpack_public_path__ + "static/Chevrolet Lanos-75b2521218ac488e65989a4443923f38.jpg";